import { SET_TOTAL_REVIEW_PENDING_ITEMS } from "../../actions/action.types";

const totalRPItems = (state = 0, action: any) => {
  if (action.type === SET_TOTAL_REVIEW_PENDING_ITEMS) return action.payload;
  else return state;
};

export default totalRPItems;
